import $ from 'jquery';
import './header-scroll';
import { debounce, isMobile } from './../../utils';
$(function () {
  var $body = $('body');
  var $header = $('.header');
  var $headerToggle = $header.find('.primary-header-toggle');
  var $navItems = $header.find('nav > ul > li');
  var $navLinks = $header.find('.primary-header__primary-nav .nav-link');
  var $primaryHeader = $header.find('.primary-header');
  var $primaryNav = $header.find('.primary-header > nav');
  var headerHeight = $primaryHeader.height();
  var windowHeight = window.innerHeight;
  init();

  ////

  function bindEvents() {
    $headerToggle.on('click touch', toggleHeader);
    $navItems.on('mouseenter', function (event) {
      return toggleSubnav(event.currentTarget, true);
    });
    $navItems.on('mouseleave', function (event) {
      return toggleSubnav(event.currentTarget, false);
    });
    $(window).on('resize', debounce(onResize, 200));
  }
  function init() {
    $primaryNav.css({
      height: ''
    });
    headerHeight = $primaryHeader.height();
    windowHeight = window.innerHeight;
    unbindEvents();
    if (isMobile()) {
      $primaryNav.css({
        height: windowHeight - headerHeight * 2 + 'px'
      });
    }
    $navLinks.removeClass('current');
    $navLinks.each(toggleCurrentNavLink);
    bindEvents();
  }
  function onResize() {
    init();
  }
  function toggleCurrentNavLink(index, navLink) {
    var $navLink = $(navLink);
    var actions = $navLink.data('action').split(',');
    if (isMobile()) {
      if (actions[0] === window.routeData.action) {
        $navLink.addClass('current');
      }
    } else {
      if (actions.includes(window.routeData.action)) {
        $navLink.addClass('current');
      }
    }
  }
  function toggleHeader() {
    var method = $header.hasClass('active') ? 'removeClass' : 'addClass';
    $body[method]('overflow-hidden');
    $header[method]('active');
  }
  function toggleSubnav(navItem, isActive) {
    var method = isActive ? 'add' : 'remove';
    navItem.classList[method]('active');
  }
  function unbindEvents() {
    $headerToggle.off('click touch', toggleHeader);
    $navItems.off('mouseenter', function (event) {
      return toggleSubnav(event.currentTarget, true);
    });
    $navItems.off('mouseleave', function (event) {
      return toggleSubnav(event.currentTarget, false);
    });
    $(window).off('resize', debounce(onResize, 200));
  }
});